import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "row"]
  // labels: translated option text passed from the ERB so JS-added rows match
  // the server-rendered ones across locales. paramKey: the actual param name
  // (server rows use planning_rule[params][<param_key>][]; keep them identical).
  static values = { shifts: Array, groups: Array, labels: Object, paramKey: String }

  add() {
    const shifts = this.shiftsValue
    const l = this.labelsValue || {}
    const pk = this.paramKeyValue || "exclusion_pairs"
    const shiftOptions = shifts.map(s => `<option value="${s.id}">${s.name}</option>`).join("")

    const row = document.createElement("div")
    row.className = "flex flex-wrap items-center gap-2 mb-2 p-2 bg-gray-50 rounded-lg"
    row.setAttribute("data-activity-exclusion-pairs-target", "row")
    row.innerHTML = `
      <select name="planning_rule[params][${pk}][][trigger_id]" class="text-xs border rounded px-2 py-1">
        <option value="">${l.trigger || "Trigger…"}</option>${shiftOptions}
      </select>
      <span class="text-xs text-gray-500">${l.not_together || ""}</span>
      <select name="planning_rule[params][${pk}][][excluded_id]" class="text-xs border rounded px-2 py-1">
        <option value="">${l.excluded || "Excluded…"}</option>${shiftOptions}
      </select>
      <select name="planning_rule[params][${pk}][][enforcement]" class="text-xs border rounded px-1 py-1">
        <option value="soft">${l.soft || "Soft"}</option>
        <option value="hard">${l.hard || "Hard"}</option>
      </select>
      <select name="planning_rule[params][${pk}][][direction]" class="text-xs border rounded px-1 py-1">
        <option value="both">${l.both || "Both"}</option>
        <option value="one_way">${l.one_way || "One-way"}</option>
      </select>
      <button type="button" data-action="activity-exclusion-pairs#remove" class="text-red-500 hover:text-red-700 text-xs">
        <i class="fas fa-times"></i>
      </button>
    `
    this.listTarget.appendChild(row)
  }

  remove(event) {
    event.target.closest("[data-activity-exclusion-pairs-target='row']").remove()
  }
}
